import { ChartArea } from 'chart.js'

const createBlueGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(9, 50, 194, 0.9)')
  gradient.addColorStop(1, 'rgba(9, 94, 194, 0.7)')
  return gradient
}

const createGreenGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(39, 151, 0, 0.9)')
  gradient.addColorStop(1, 'rgba(122, 191, 9, 0.7)')
  return gradient
}

const createRedGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(219, 26, 0, 0.9)')
  gradient.addColorStop(1, 'rgba(231, 89, 28, 0.7)')
  return gradient
}

const createPurpleGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(128, 0, 128, 0.9)') // Dark Purple
  gradient.addColorStop(1, 'rgba(186, 85, 211, 0.7)') // Medium Orchid
  return gradient
}

const createOrangeGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(255, 165, 0, 0.9)') // Orange
  gradient.addColorStop(1, 'rgba(255, 215, 0, 0.7)') // Gold
  return gradient
}

const createYellowGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(255, 255, 0, 0.9)') // Yellow
  gradient.addColorStop(1, 'rgba(255, 215, 0, 0.7)') // Gold
  return gradient
}

const createCyanGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(0, 255, 255, 0.9)') // Cyan
  gradient.addColorStop(1, 'rgba(0, 139, 139, 0.7)') // Dark Cyan
  return gradient
}

const createMagentaGradient = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
): CanvasGradient => {
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0.2, 'rgba(255, 0, 255, 0.9)') // Magenta
  gradient.addColorStop(1, 'rgba(139, 0, 139, 0.7)') // Dark Magenta
  return gradient
}

export const gradients = {
  blue: createBlueGradient,
  green: createGreenGradient,
  red: createRedGradient,
  purple: createPurpleGradient,
  orange: createOrangeGradient,
  yellow: createYellowGradient,
  cyan: createCyanGradient,
  magenta: createMagentaGradient,
}
